import { personInfoFrag } from '../../../../../utils/type/person.common-type';
import { userInfoFrag } from '../../../../../utils/type/user.common-type';

export const getWorksFrag = `
    id
    dateFrom
    dateTo
    folderId
    serviceId
    person {
        ${personInfoFrag}
    }
    users {
        ${userInfoFrag}
    }
    workType
    workData {
        ... on WorkDataMovementRestrictionObject {
            type
            data
            witness
            location
            sequenceNumber
            users {
                id
                userId
                name
            }
        }
    }
    emailHistory {
        id
        createdAt
    }
`;
